module.exports = __webpack_public_path__ + "static/media/computer.54ff7572.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/undergrad/computer.png
// module id = 483
// module chunks = 0